export const checkUserLocation = (restaurantCoords, userCoords) => {
  const { latitude, longitude } = userCoords;

  const [restLong, restLat] = restaurantCoords;

  const R = 6371; // Earth radius in km
  const dLat = ((restLat - latitude) * Math.PI) / 180;
  const dLon = ((restLong - longitude) * Math.PI) / 180;

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(latitude * Math.PI / 180) *
      Math.cos(restLat * Math.PI / 180) *
      Math.sin(dLon / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;

  return {
    distance,
    isInside: distance < 0.2, // within 100m
    canOrder: distance <= 20, // within 20km
  };
};


function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; 
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

